import { render } from "./hero.vue?vue&type=template&id=19a0bcba&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=19a0bcba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19a0bcba"

export default script